// src/hooks/useTick.ts
// Перерисовка раз в period мс — чтобы «нет данных от робота» появлялось, даже когда сообщения перестали приходить.
import { useEffect, useState } from 'react';

export function useTick(period = 1000) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick(x => x + 1), period);
    return () => clearInterval(t);
  }, [period]);
}
